import type { ValueOf } from "ts-essentials";

export type MEMBERSHIP_TYPE = ValueOf<typeof MEMBERSHIP_TYPE>;
export const MEMBERSHIP_TYPE = {
  /// "\"All\" is only valid for searching capabilities: you need to pass the actual matching BungieMembershipType for any query where you pass a known membershipId."
  all: -1,
  none: 0,
  xbox: 1,
  psn: 2,
  steam: 3,
  blizzard: 4,
  // rip
  stadia: 5,
  egs: 6,
  demon: 10,
  bungie: 254,
} as const;
